// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"thumb-up-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7.5 11.1L11.1 3L11.9538 3.28461C13.0563 3.65211 13.8 4.68389 13.8 5.84605V9.3H18.6688C19.8945 9.3 20.8319 10.3926 20.6455 11.6041L19.4609 19.3041C19.3108 20.2798 18.4713 21 17.4842 21H7.5V11.1Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M7.5 11.0996V20.9996H3V11.0996H7.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.5 11.1V21M7.5 11.1L11.1 3L11.9538 3.28461C13.0563 3.65211 13.8 4.68389 13.8 5.84605V9.3H18.6688C19.8945 9.3 20.8319 10.3926 20.6455 11.6041L19.4609 19.3041C19.3108 20.2798 18.4713 21 17.4842 21H7.5M7.5 11.1H3V21H7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ThumbUp2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-up-2',
    ref,
    icon: element,
  },
));

ThumbUp2Icon.displayName = 'ThumbUp2Icon';

export default ThumbUp2Icon;
